// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { Addon } from './addon';
import { AddonBin } from './addon-bin';
import { AddonBinStationStatus } from './addon-bin-station-status';
import { ItemDetail } from './item-detail';
import { JoDetail } from './jo-detail';
import { AddonBinStationStatusEnum } from './enums';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class ItemDetailAddon extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  /** Int32 key */
  id!: number;
  /** String(255) */
  additionalInfo?: string;
  /** Int32 FK addonBin */
  addonBinId?: number;
  /** Enum FK addonBinStationStatus */
  addonBinStationStatusId?: AddonBinStationStatusEnum;
  /** Int32 FK addon */
  addonId!: number;
  /** String(12) FK itemDetail */
  itemDetailId!: string;
  /** DateTimeOffset */
  modTs!: Date;
  /** String(4) */
  modUserInit!: string;
  /** Int32 FK supersededByJoDetail */
  supersededByJoDetailId?: number;
  /** DateTimeOffset */
  supersededTs?: Date;
  /** FK addonId */
  addon!: Addon;
  /** FK addonBinId */
  addonBin!: AddonBin;
  /** FK addonBinStationStatusId */
  addonBinStationStatus!: AddonBinStationStatus;
  /** FK itemDetailId */
  itemDetail!: ItemDetail;
  /** FK supersededByJoDetailId */
  supersededByJoDetail!: JoDetail;
}

